export default __webpack_public_path__ + "media/sermorelinEligibleHero.49803ffcc9d1ee43b2f59a9e92ccf98d.webp";